"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var formik_1 = require("formik");

var styled_1 = __importDefault(require("@emotion/styled"));

var react_web_components_1 = require("@nimles/react-web-components");

var react_web_components_2 = require("@nimles/react-web-components");

var react_2 = require("@emotion/react");

var LicensePlate = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  border-radius: 0.4em;\n  margin: 10px auto;\n  overflow: hidden;\n  background-color: #fff;\n  color: white;\n  width: 21em;\n  border: 1px solid ", ";\n"], ["\n  display: flex;\n  border-radius: 0.4em;\n  margin: 10px auto;\n  overflow: hidden;\n  background-color: #fff;\n  color: white;\n  width: 21em;\n  border: 1px solid ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.input.borderColor;
});
var EuSign = styled_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-family: sans-serif;\n  font-weight: 400;\n  line-height: 1;\n  text-align: center;\n  border: none;\n  flex: 0 0 2em;\n  padding: 0.1em;\n  color: ", ";\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n"], ["\n  font-family: sans-serif;\n  font-weight: 400;\n  line-height: 1;\n  text-align: center;\n  border: none;\n  flex: 0 0 2em;\n  padding: 0.1em;\n  color: ", ";\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n"])), function (_a) {
  var theme = _a.theme;
  return theme.input.color;
});
var CountryCode = styled_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-size: 1.5em;\n"], ["\n  font-size: 1.5em;\n"])));
var PlateNumber = styled_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  border: none;\n  text-align: center;\n  flex: 0 0 15em;\n  text-transform: uppercase;\n  font-family: 'Helvetica', sans-serif;\n  color: #757575;\n  background-color: white;\n  outline: none !important;\n  border-top-right-radius: 0.15em;\n  border-bottom-right-radius: 0.15em;\n"], ["\n  border: none;\n  text-align: center;\n  flex: 0 0 15em;\n  text-transform: uppercase;\n  font-family: 'Helvetica', sans-serif;\n  color: #757575;\n  background-color: white;\n  outline: none !important;\n  border-top-right-radius: 0.15em;\n  border-bottom-right-radius: 0.15em;\n"])));
var Input = styled_1.default.input(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  box-sizing: border-box;\n  border: none;\n  font-size: 3.2em;\n  line-height: 1.3em;\n  height: 1.3em;\n  width: 100%;\n  padding: 0 10px;\n  margin: 0;\n  text-transform: uppercase;\n  font-family: 'Helvetica', sans-serif;\n  color: ", ";\n  background-color: white;\n  outline: none !important;\n  border-top-right-radius: 0.15em;\n  border-bottom-right-radius: 0.15em;\n"], ["\n  box-sizing: border-box;\n  border: none;\n  font-size: 3.2em;\n  line-height: 1.3em;\n  height: 1.3em;\n  width: 100%;\n  padding: 0 10px;\n  margin: 0;\n  text-transform: uppercase;\n  font-family: 'Helvetica', sans-serif;\n  color: ", ";\n  background-color: white;\n  outline: none !important;\n  border-top-right-radius: 0.15em;\n  border-bottom-right-radius: 0.15em;\n"])), function (_a) {
  var theme = _a.theme;

  var _b, _c, _d;

  return _d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.input) === null || _c === void 0 ? void 0 : _c.color, _d !== null && _d !== void 0 ? _d : react_web_components_1.defaultTheme.input.color;
});
var SearchButton = styled_1.default.button(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  border: none;\n  background-color: transparent;\n  color: ", ";\n  flex: 0 0 4em;\n  padding: 1em;\n  font-size: 1em;\n  cursor: pointer;\n  height: 4em;\n  width: 4em;\n"], ["\n  border: none;\n  background-color: transparent;\n  color: ", ";\n  flex: 0 0 4em;\n  padding: 1em;\n  font-size: 1em;\n  cursor: pointer;\n  height: 4em;\n  width: 4em;\n"])), function (_a) {
  var theme = _a.theme;

  var _b, _c, _d;

  return _d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.input) === null || _c === void 0 ? void 0 : _c.color, _d !== null && _d !== void 0 ? _d : react_web_components_1.defaultTheme.input.color;
});

exports.LicensePlateInput = function (_a) {
  var _b, _c, _d, _e, _f, _g;

  var field = _a.field,
      errors = _a.form.errors,
      // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  options = _a.options,
      onSearch = _a.onSearch,
      dark = _a.dark,
      props = __rest(_a, ["field", "form", "options", "onSearch", "dark"]);

  var theme = react_2.useTheme();
  return react_1.default.createElement("div", null, react_1.default.createElement(LicensePlate, null, react_1.default.createElement(EuSign, null, react_1.default.createElement(react_web_components_2.EuStars, {
    style: {
      width: '100%',
      height: 'auto'
    },
    color: (_d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.input) === null || _c === void 0 ? void 0 : _c.color, _d !== null && _d !== void 0 ? _d : react_web_components_1.defaultTheme.input.color)
  }), react_1.default.createElement(CountryCode, null, "S")), react_1.default.createElement(PlateNumber, null, react_1.default.createElement(Input, __assign({
    "data-lpignore": "true",
    id: field.name
  }, field, props, {
    placeholder: "reg nr"
  }))), react_1.default.createElement(SearchButton, {
    className: "license-plate__search-btn",
    onClick: function onClick(e) {
      if (onSearch) {
        e.preventDefault();
        onSearch(field.value);
      }
    }
  }, react_1.default.createElement(react_web_components_2.Magnifier, {
    color: (_g = (_f = (_e = theme) === null || _e === void 0 ? void 0 : _e.input) === null || _f === void 0 ? void 0 : _f.color, _g !== null && _g !== void 0 ? _g : react_web_components_1.defaultTheme.input.color)
  }))), react_1.default.createElement("div", null, errors[field.name]));
};

exports.LicensePlateField = function (props) {
  return react_1.default.createElement(formik_1.Field, __assign({}, props, {
    component: exports.LicensePlateInput
  }));
};

var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;